module.exports = __webpack_public_path__ + "static/media/mulan-circle.8c5952f0.svg";